import React from "react";
import { Box, Typography, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        px: 4,
        py: 2,
        background: "linear-gradient(60deg,#0D2A54, #1A4B83, #2B6BA5)",
        color: "#fff",
        display: "flex",
        flexDirection: { xs: "column", md: "row", sm: 'row' },
        justifyContent: "space-between",
        alignItems: "center",
        gap: 2,

      }}
    >
      {/* Left Section */}
      <Typography sx={{ fontSize: 16 }}>
        &copy; {new Date().getFullYear()} GetMyRank. All rights reserved.
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: 3,
          flexWrap: "wrap",
          flexDirection: { xs: "column", md: "row", sm: 'row' },
        }}
      >
        <Typography
          onClick={() => navigate("/about-us")}
          sx={{
            color: "#fff",
            textDecoration: "none",
            fontWeight: "bold",
            cursor: "pointer",
            ":hover": {
              color: "#FFD700",
            },
          }}
        >
          About Us
        </Typography>

        <Typography
          onClick={() => navigate("/privacy-policy")}
          sx={{
            color: "#fff",
            textDecoration: "none",
            fontWeight: "bold",
            cursor: "pointer",
            ":hover": {
              color: "#FFD700",
            },
          }}
        >
          Privacy Policy
        </Typography>
        <Typography
          onClick={() => navigate("/terms-and-conditions")}
          sx={{
            color: "#fff",
            textDecoration: "none",
            fontWeight: "900",
            cursor: "pointer",
            ":hover": {
              color: "#FFD700",
              fontWeight: "bold",
            },
          }}
        >
          Terms and Conditions
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;

